module.exports = __webpack_public_path__ + "img/log_2B.2fa7c672.png";